import React from 'react'
import { headerVariants } from '@web/modules/message-preview/styles'

interface HeaderProps {
  text: string
}

const { container } = headerVariants()

const Header = ({ text }: HeaderProps) => <p className={container()}>{text}</p>

export default Header
